"use strict";
import { RoundedCandleSeriesRenderer } from "components/Charts/PriceChart/RoundedCandlestickSeries/renderer";
import {
  customSeriesDefaultOptions
} from "lightweight-charts";
const defaultOptions = {
  ...customSeriesDefaultOptions,
  upColor: "#26a69a",
  downColor: "#ef5350",
  neutralColor: "#26a69a",
  wickVisible: true,
  borderVisible: true,
  borderColor: "#378658",
  borderUpColor: "#26a69a",
  borderDownColor: "#ef5350",
  wickColor: "#737375",
  wickUpColor: "#26a69a",
  wickDownColor: "#ef5350",
  radius(bs) {
    if (bs < 4) {
      return 0;
    }
    return bs / 3;
  }
};
export class RoundedCandleSeries {
  _renderer;
  constructor() {
    this._renderer = new RoundedCandleSeriesRenderer();
  }
  priceValueBuilder(plotRow) {
    return [plotRow.high, plotRow.low, plotRow.close];
  }
  renderer() {
    return this._renderer;
  }
  isWhitespace(data) {
    return data.close === void 0;
  }
  update(data, options) {
    this._renderer.update(data, options);
  }
  defaultOptions() {
    return defaultOptions;
  }
}
